import { useMutation } from "@apollo/client";
import {
    constantsData,
    identifiersData,
    namesData,
    statusTypesData,
} from "data";
import { createClientFoldersStructureFolderMutation, getClientQuery } from "graph";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { openAlert } from "redux/actions";
import { displayErrorHandler } from "utils";

const useCreateClientFoldersStructureFolder = (clientId) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const [createClientFoldersStructureFolderAction, { loading }] = useMutation(
        createClientFoldersStructureFolderMutation,
        {
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: getClientQuery,
                    variables: {
                        where: { id: clientId },
                    },
                },
            ],
        },
    );

    const { createClientFoldersStructureFolderPending: createClientFoldersStructureFolderPendingToastName } = namesData.toasts;

    const { toast: toastId } = identifiersData.ids;

    const createClientFoldersStructureFolder = async ({
        isSelection,
        name,
        parentPath,
    }) => {
        try {
            await createClientFoldersStructureFolderAction({
                onCompleted: () => {
                    dispatch(openAlert(
                        t(
                            "messages.createMsgs.success",
                            { entity: t("labels.folder") },
                        ),
                        statusTypesData.success,
                    ));
                },
                variables: {
                    clientId,
                    isSelection,
                    name,
                    parentPath,
                    type: constantsData.folder,
                },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        } finally {
            toast.dismiss(`${createClientFoldersStructureFolderPendingToastName}_${toastId}`);
        }
    };

    useEffect(
        () => {
            if (loading) {
                toast.info(
                    () => t(
                        "messages.createMsgs.pending",
                        { entity: t("labels.folder") },
                    ),
                    { toastId: `${createClientFoldersStructureFolderPendingToastName}_${toastId}` },
                );
            }
        },
        [loading], //eslint-disable-line
    );

    return {
        createClientFoldersStructureFolder,
        loading,
    };
};

export default useCreateClientFoldersStructureFolder;
